import React, { useContext, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import CustomDialog from '@/product/components/organisms/Dialog'
import SettingContext from '@/product/context/setting/settingContext'
import MessageContext from '@/product/context/message/messageContext'
import { IconButton } from '@mui/material'
import { Button } from '@mui/material'
import * as Yup from 'yup'
import { mapData } from '@/product/common/components'
import SettingCustomContext from '@/custom/context/setting/settingContext'
const Disputes = () => {
    const settingcontext = useContext(SettingContext)

    const SettingCustomContexts = useContext(SettingCustomContext)
    const { settingChangeStatus, responseStatus, clearResponse } =
        SettingCustomContexts
    const today = new Date()
    const [openData, setData] = useState(null)
    const currentYear = today.getFullYear()
    const {
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext
    const messageContext = useContext(MessageContext)
    const {
        searchactualmessages,
        getAllMessages,
        searchprojectmessages,
        all_messages,
        all_actual_messages,
        all_project_messages,
        deleteMessage,
        searcharchiveMessages,
        saveMessage,
        responseStatus: responseStatusMessage,
    } = messageContext
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState(false)
    const [open, setOpen] = useState(false)
    const [allData, setAllData] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [selectedSeller, setSelectedSeller] = useState(0)
    const validationArray = Yup.object({
        message: Yup.string().required('Required'),
    })

    const formik = useFormik({
        initialValues: {
            message: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            let messageFormData = {
                ...values,
                attachinsidename: '',
                attachorginalname: '',
                sellermsgpost: selectedSeller?.buyer_id,
                projectmsgpost: selectedSeller?.product_id,
                status: 'open',
                fromadmin: 1,
            }
            saveMessage(messageFormData)
            // handleMessageSubmit(values)
            setManage(false)
            formik.handleReset()
        },
    })

    const message = [
        {
            label: 'Message Buyer',
            placeholder: `Type message to buyer`,
            class: 'col-md-12',
            name: 'message',
            formik: formik,
        },
    ]
    const closePopUp = () => {
        setManage(false)
        formik.handleReset()
    }

    const formikFetch = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'dis.id',
            primaryTable: 'disputes',

            tableJoins: [
                {
                    baseTable: 'users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'user_id',
                },
            ],
            filters: {
                users_first_name: {
                    type: 'like',
                    value: '',
                    field: 'u.first_name,u.username,u.last_name',
                },
                users_status: {
                    type: 'in',
                    value: 'active',
                    field: 'dis.status',
                },
                users_email: {
                    type: 'like',
                    value: '',
                    field: 'u.email',
                },
            },
        },
        onSubmit: (values) => {
            let valueNew = JSON.parse(JSON.stringify(values))
            valueNew.filters.users_status.value =
                values.filters.users_status.value == 'all'
                    ? ''
                    : values.filters.users_status.value

            searchTableFetch(valueNew, 'disputes')
            setIsLoading(true)
        },
    })

    useEffect(() => {
        setTableBody([])
        setIsLoading(true)
        searchTableFetch(formikFetch.values, 'disputes')
    }, [])
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'changeStatus') {
                if (responseStatus.status === 'success') {
                    setChangeStatus(false)
                    formikFetch.handleSubmit()
                } else {
                }
            }
            clearResponse()
        }
    }, [responseStatus])
    const onClickEdit = (id, secondaryID, type) => {
        if (type == 'buyer_journey') {
            if (tableBody.length) {
                let data = tableBody.find((ele) => ele.id == id)
                setData(data || {})
                setOpen(true)
            }
        } else {
            setSelectedSeller({ buyer_id: id, product_id: secondaryID })
            setManage(true)
        }
    }
    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            field: 'action',
            type: 'button',
            clickType: 'buyer_journey',
            clickID: 'id',
            buttonType: 'visibility',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Comment',
            tooltipTitle: 'View Comment',
        })
        actionPush.push({
            buttonType: 'message',
            clickType: 'editIncrement',
            clickID: 'user_id',
            onclick: onClickEdit,
            secondaryClickID: 'project_id',
            tooltipTitle: 'Send Message',
        })

        return actionPush
    }
    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'disputes') {
                search_fetch_data.records.map((ele) => {
                    ele.status =
                        ele.status == 'removed' ? 'resolved' : ele.status
                })
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])
    const formikSelection = useFormik({
        initialValues: {
            active: 'removed',
            id: [],
            primaryTable: 'disputes',
            columnName: 'status',
            buynow_id: [],
            updateBuynow: true,
        },
        onSubmit: (values) => {
            settingChangeStatus(values)
        },
    })
    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        let arr = []
        data.map((ele) => {
            arr.push(tableBody.find((ele2) => ele2.id == ele)?.buynow_id)
        })
        formikSelection.values.buynow_id = arr
        setChangeStatus(true)
    }

    const tableValues = [
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'First Name',
            filterable: true,
            filter: true,
            filterField: 'u.first_name',
        },
        {
            field: 'users_last_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Last Name',
            filter: true,
            filterable: true,
            filterField: 'u.last_name',
        },
        {
            field: 'users_username',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'UserName',
            filter: true,
            filterable: true,
            filterField: 'u.username',
        },

        {
            field: 'subject',
            type: '',
            firstChild: true,
            sort: false,
            disablePadding: false,
            label: 'Subject',
            filterable: false,
        },
        {
            field: 'message',
            type: '',
            firstChild: true,

            sort: false,
            filterField: 'dis.message',
            disablePadding: true,
            label: 'Message',
            filterable: false,
        },
        {
            field: 'status',
            type: 'capitalize',
            firstChild: true,
            disablePadding: false,
            label: 'Status',
            filterable: true,
            filterField: 'dis.status',
            filter: true,
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            disablePadding: false,
            label: 'Created At',
            filterable: true,
            filterField: 'dis.created_at',
            filter: true,
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const searchInfo = {
        formik: formikFetch,
        data: [
            {
                label: 'UserName/First Name/Last Name',
                placeholder: 'Search UserName/First Name/Last Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'users_first_name',
                filter: true,
            },
            {
                label: 'Dispute Status',
                placeholder: 'Select Dispute Status',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'select',
                options: [
                    {
                        show: 'All',
                        value: 'all',
                    },
                    {
                        show: 'Active',
                        value: 'active',
                    },
                    {
                        show: 'Resolved',
                        value: 'removed',
                    },
                ],
                name: 'users_status',
                filter: true,
            },
        ],
    }
    const tableActions = [
        {
            label: 'Move to Resolved',
            icon: <span className="material-icons">done_outline</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        },
    ]
    const paginationHandler = (formik) => {
        const updatedFilters = {
            ...formik.filters,
            users_status: {
                ...formik.filters.users_status,
                value:
                    formik.filters.users_status.value === 'all'
                        ? ''
                        : formik.filters.users_status.value,
            },
        }

        searchTableFetch({
            ...formik,
            filters: updatedFilters,
        })
    }

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch
                    // incudeTimelineFilter={true}
                    searchInfo={searchInfo}
                    formik={formikFetch}
                />
                <div className="d-flex justify-content-between align-items-center mt-4"></div>
                <CustomTable
                    formik={formikFetch.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    isLoading={isLoading}
                    loadingTemplate={'table'}
                    changeTableFunction={paginationHandler}
                    fromVariable={'disputes'}
                />
                {manage && (
                    <CustomDialog
                        title={
                            <div className="d-flex align-items-center justify-content-between">
                                Message Buyer
                                <IconButton onClick={() => closePopUp(false)}>
                                    <span className="material-icons">
                                        clear
                                    </span>
                                </IconButton>
                            </div>
                        }
                        open={manage}
                    >
                        <form>
                            <div className="row mb-4">
                                {Object.values(mapData(message))}
                            </div>
                            <div className="actionWrapper">
                                <PrimaryButton
                                    onClick={formik.handleSubmit}
                                    id="confirm_bid_submit"
                                    type="button"
                                    label={'Submit'}
                                />
                            </div>
                        </form>
                    </CustomDialog>
                )}
                <CustomDialog
                    title="Dispute"
                    open={open}
                    function={() => setOpen(false)}
                    className="userStatusCstmDialog"
                >
                    <>
                        <h5
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            Subject:
                        </h5>
                        <h6>{openData?.subject}</h6>

                        <h5
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            Message:
                        </h5>
                        <h6>{openData?.message}</h6>

                        {openData?.file_upload && (
                            <div className="mt-3">
                                <img
                                    src={
                                        global.site_url +
                                        '/uploads/messages/' +
                                        openData?.file_upload
                                    }
                                    alt="Dispute attachment"
                                    className="usersfield"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '250px',
                                        objectFit: 'contain',
                                        borderRadius: '6px',
                                        border: '1px solid #ccc',
                                    }}
                                />
                            </div>
                        )}

                        <div className="actionWrapper mt-4 text-center">
                            <PrimaryButton onClick={() => setOpen(false)}>
                                Close
                            </PrimaryButton>
                        </div>
                    </>
                </CustomDialog>

                <CustomDialog
                    title={'Confirm'}
                    open={changeStatus}
                    function={changeChangeStatus}
                >
                    <h5>Are you sure this dispute is resolved?</h5>
                    <div className="actionWrapper">
                        <Button
                            id="location_cancel"
                            onClick={() => changeChangeStatus()}
                        >
                            Cancel
                        </Button>
                        <form
                            onSubmit={formikSelection.handleSubmit}
                            autoComplete="nofill"
                        >
                            <PrimaryButton
                                id="location_confirm"
                                type="submit"
                                label="Confirm"
                            />
                        </form>
                    </div>
                </CustomDialog>
            </div>
        </Layout>
    )
}

export default Disputes
